module.exports = __webpack_public_path__ + "img/dice-1.8740db33.svg";